import { render, staticRenderFns } from "./reviews-config-settings.vue?vue&type=template&id=19674e78&"
import script from "./reviews-config-settings.vue?vue&type=script&lang=ts&"
export * from "./reviews-config-settings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports